// src/components/Apis/userManagement.js
const storageKey = "user";
const loginPaths = ["/login", "/auth/login"]; // widen if needed

function safeReadUser() {
  try {
    const raw = localStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function isOnLogin() {
  const path = window.location.pathname;
  return loginPaths.some(p => path === p || path.endsWith(p));
}

const UserProfile = (() => {
  const setUser = (data) => {
    localStorage.setItem(storageKey, JSON.stringify(data || {}));
    return true;
  };

  const getUser = () => safeReadUser();

  const isLoggedIn = () => {
    const user = safeReadUser();
    return Boolean(user && user.token);
  };

  const getToken = () => {
    const user = safeReadUser();
    if (user && user.token) return user.token;

    // Avoid redirect loops on login page
    if (!isOnLogin()) {
      logout(); // hard redirect below
    }
    return null;
  };

  const logout = () => {
    localStorage.removeItem(storageKey);

    // optional: notify other tabs
    try { localStorage.setItem("__logout_broadcast__", String(Date.now())); } catch {}

    // optional: preserve return URL (unless already on login)
    const returnTo = !isOnLogin() ? encodeURIComponent(window.location.pathname + window.location.search) : "";
    const to = returnTo ? `/login?returnTo=${returnTo}` : "/login";

    // Hard redirect (no back)
    window.location.replace(to);
    return true;
  };

  return { getUser, setUser, isLoggedIn, logout, getToken };
})();

// Optional: listen for logout from other tabs
window.addEventListener("storage", (e) => {
  if (e.key === "__logout_broadcast__") {
    // another tab logged out
    if (!isOnLogin()) window.location.replace("/login");
  }
});

export default UserProfile;
